module.exports = __webpack_public_path__ + "d0803899f315c99ad34715577aebf2b1.svg";